import { initialStateForCampaignSlice } from "../pages/campaigns/campaignSlice";
import { initialStateForWishlistSlice } from "../pages/company-wishlist/wishlistSlice";
import { initialStateForDashboardSlice } from "../pages/dashboard/dashboardSlice";
import { initialStateForCommonSlice } from "./commonSlice";
export const migrations = {
  0: (state) => state, // default, no change
  1: (state) => {
    return {
      ...state,
      campaignSlice: initialStateForCampaignSlice, // Reset this slice
      // Only reset slices if you changed their shape
      dashboardSlice: initialStateForDashboardSlice,
      commonSlice: initialStateForCommonSlice,
      wishlistSlice: initialStateForWishlistSlice,
    };
  },
  // Add future versions here
};